import controller from './bgvTracker.controller';
import template from './bgvTracker.pug';

const BgvtrackerComponent = {
  template,
  controller,
};

export default BgvtrackerComponent;



// WEBPACK FOOTER //
// ./client/app/reports/bgvTracker/bgvTracker.component.js